export class OperatingSystemDetector {
	constructor() {
		this.OperatingSystemItems = {
			MacOS: 'MacOS',
			Windows: 'Windows',
			Linux: 'Linux',
			Android: 'Android'
		};
	}

	getOS() {
		let userAgent = window.navigator.userAgent;
		let platform = window.navigator.platform;
		let macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
		let windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
		let iosPlatforms = ['iPhone', 'iPad', 'iPod'];

		if(macosPlatforms.indexOf(platform) !== -1) {
			return this.OperatingSystemItems.MacOS;
		}
		else if(iosPlatforms.indexOf(platform) !== -1) {
			return this.OperatingSystemItems.iOS;
		}
		else if(windowsPlatforms.indexOf(platform) !== -1) {
			return this.OperatingSystemItems.Windows;
		}
		else if(/Linux/.test(platform)) {
			return this.OperatingSystemItems.Linux;
		}
		else if(/Android/.test(userAgent)) {
			return this.OperatingSystemItems.Android;
		}
	}
}

export let operatingSystemDetector = new OperatingSystemDetector();
